import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-record\">\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\">\n        <circle cx=\"12\" cy=\"12\" r=\"8.5\" stroke=\"#000\" />\n        <circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"#000\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol